import { Checkbox, Grid, ListSubheader, MenuItem, Switch, TextField, Typography } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import FlexView from 'react-flexview/lib'
import { useFormContext } from 'react-hook-form'
import { vinValidation } from '../../../services/utils'
import { GlobalTextField } from '../../Core/Input/ControlledTextField'
import { reportGTM } from '../../Core/Utilities/GTagManger'

//Need to validate it in ui refactoring
export const NewVehicleSection = () => {
  const methods = useFormContext()
  const [checked, setChecked] = React.useState(false)

  const handleCheckboxChange = event => {
    setChecked(event.target.checked)

    if (event.target.checked) {
      reportGTM('', '', { event: 'add-vin-later-trigger', at: window.location.pathname })
    }
  }

  return (
    <>
      <Grid item xs={12} sm={6} md={3}>
        <Typography>Year, Make, Model</Typography>
        <GlobalTextField
          fullWidth
          name="new_vehicle_req_details"
          register={methods.register}
          errors={methods.errors}
          helperText={!!methods.errors.new_vehicle_req_details && 'Required'}
          inputRef={methods.register({ required: true })}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <Typography>Motorcycle Actual Cash Value</Typography>
        <GlobalTextField
          fullWidth
          name="value"
          register={methods.register}
          errors={methods.errors}
          helperText={!!methods.errors.value && 'Required'}
          inputRef={methods.register({ required: true })}
          type="number"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <Typography>Vehicle identification number (VIN)</Typography>
        <GlobalTextField
          fullWidth
          name="vin"
          register={methods.register}
          errors={methods.errors}
          helperText={!!methods.errors.vin && methods.errors.vin.type == 'required' ? 'Required' : 'Vin must contain 17 characters'}
          inputRef={methods.register({ required: !checked, maxLength: 17, minLength: 17 })}
          onChange={vinValidation}
          type="number"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <div className="text-tiny black">Don't have your VIN number?</div>
        <FlexView vAlignContent={'center'} className="text-overflow-elipsis">
          <Checkbox color="primary" checked={checked} onChange={handleCheckboxChange} inputProps={{ 'aria-label': 'controlled' }} />
          <div className="text-tiny black">Add it later</div>
        </FlexView>
      </Grid>
    </>
  )
}
